import script from "./ViewBase.vue?vue&type=script&lang=ts"
export * from "./ViewBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__